<div class="cf-flex-column cf-justify-content-center cf-align-items-center cf-fill">
  <mat-card appearance="outlined" aria-label="Reset password" class="reset-password-card mat-elevation-z8">
    <mat-toolbar color="accent" class="header cf-flex-column cf-justify-content-space-between cf-align-items-center">
      <mat-toolbar-row class="cf-flex-row cf-justify-content-space-between cf-align-items-center">
        <button [routerLink]="['/login']" mat-button class="login-button">
          <mat-icon aria-hidden="false" aria-label="Login arrow backward icon">arrow_backward</mat-icon>
          <span [translate]="'UI.Login'"></span>
        </button>
        <h1 [translate]="'UI.ResetPassword'"></h1>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-card-content class="content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field class="form-field" appearance="outline">
          <mat-label [translate]="'UI.Password'"></mat-label>
          <input
            type="password"
            matInput
            formControlName="password"
            aria-label="password"
            required
            autocomplete="current-password"
            (input)="onPasswordInput()"
          />
          @if (password.invalid && (password.dirty || password.touched) && password.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"></mat-error>
          }
          @if (password.invalid && (password.dirty || password.touched) && password.errors.minlength) {
            <mat-error
              [translate]="'UI.Error.PasswordMinLength'"
              [translateParams]="{ numberOfMinCharacters: password.errors.minlength.requiredLength }"
            >
              ></mat-error
            >
          }
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label [translate]="'UI.ConfirmPassword'"></mat-label>
          <input
            type="password"
            matInput
            formControlName="confirmPassword"
            aria-label="confirm password"
            required
            (input)="onPasswordInput()"
          />
          @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched) && confirmPassword.errors.required) {
            <mat-error [translate]="'UI.Error.Required'"> ></mat-error>
          }
          @if (
            confirmPassword.invalid &&
            (confirmPassword.dirty || confirmPassword.touched) &&
            !confirmPassword.errors.required &&
            confirmPassword.errors.passwordMismatch
          ) {
            <mat-error [translate]="'UI.Error.PasswordsDoNotMatch'"> ></mat-error>
          }
        </mat-form-field>
        <button
          type="submit"
          mat-raised-button
          class="reset-button primary-button"
          aria-label="reset password"
          [disabled]="!form.valid || (isLoading$ | async)"
        >
          {{ 'UI.ResetPassword' | translate }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
